// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__16dpr","obliqueLineWrap":"membershipbadge_obliqueLineWrap__lGfP4","obliqueLine":"membershipbadge_obliqueLine__2hqBw"};